export const WELCOME = '/'
export const PROJECTS = '/projects'
export const STUDIO_ART = '/art'
export const ABOUT = '/about'
export const CONTACT = '/contact'